/* eslint-disable no-magic-numbers */
import { metricsBus } from "buses";
import recombeeClient from "./recombeeClient";
import experimentService from "services/experiment/experimentService";
import { EXPERIMENT_RECOMBEE_TRENDING_FEED, VARIANT_CONTROL, VARIANT_TREATMENT } from "services/experiment/constants";

const isInteractionAllowed = async () => {
  const isWatchPage = window.location.pathname.indexOf("/watch/") === 0;
  if (isWatchPage) {
    return true;
  }

  const variant = await experimentService.getVariant(EXPERIMENT_RECOMBEE_TRENDING_FEED, VARIANT_CONTROL);
  return variant === VARIANT_TREATMENT;
};

metricsBus.on("gifView", async ({ gifId }) => {
  if (await isInteractionAllowed()) {
    recombeeClient.sendDetailView(gifId);
  }
});

metricsBus.on("gifPlayback", async ({ gif, percent }) => {
  if (await isInteractionAllowed()) {
    recombeeClient.sendPortionView(gif, percent / 100);
  }
});

metricsBus.on("addedToCollection", async ({ gifId }) => {
  if (await isInteractionAllowed()) {
    recombeeClient.sendAddBookmark(gifId);
  }
});

metricsBus.on("gifLiked", async ({ gifId }) => {
  if (await isInteractionAllowed()) {
    recombeeClient.sendAddRating(gifId, 1);
  }
});
